import React from "react";
import DatePicker, {registerLocale} from "react-datepicker";
import {fr} from "date-fns/locale";
import Banner from "components/banner/banner";
import Button from "components/button";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";

registerLocale("fr-FR", fr);

const EndValidityStep = ({
    translate,
    endDate,
    onEndDateChange,
    wasDateRead,
    isConfirming,
    errorMessage,
    onClose,
    onConfirm,
}) => {
    const canConfirm = Boolean(endDate) && !isConfirming;

    return (
        <>
            <Modalheader hide={onClose} hideShow={!isConfirming}>
                {translate("date_title")}
            </Modalheader>
            <ModalBody>
                <div className="flex flex-col gap-4">
                    <p className="ft-b text-gray-700">{translate("date_text")}</p>
                    <div className="flex flex-col gap-1">
                        <label htmlFor="visa-extension-end-validity" className="ft-sm font-medium text-gray-500">
                            {translate("date_label")}
                        </label>
                        <DatePicker
                            id="visa-extension-end-validity"
                            dateFormat="dd/MM/yyyy"
                            placeholderText={translate("date_placeholder")}
                            selected={endDate}
                            onChange={onEndDateChange}
                            minDate={new Date()}
                            locale="fr-FR"
                            disabled={isConfirming}
                            popperPlacement="auto"
                            popperProps={{strategy: "fixed"}}
                            popperClassName="z-[9999]"
                            className="w-full h-10 pl-3 pr-3 border rounded-lg"
                        />
                        {!wasDateRead && (
                            <p className="ft-sm text-gray-500">{translate("date_unread")}</p>
                        )}
                    </div>
                    {errorMessage && <Banner type="alert">{errorMessage}</Banner>}
                </div>
            </ModalBody>
            <ModalFooter>
                <Button size={"LG"} color={"SECONDARY"} disabled={isConfirming} onClick={onClose}>
                    {translate("cancel")}
                </Button>
                <Button
                    size={"LG"}
                    color={canConfirm ? "PRIMARY" : "DISABLED"}
                    disabled={!canConfirm}
                    onClick={onConfirm}
                >
                    {translate("confirm")}
                </Button>
            </ModalFooter>
        </>
    );
};

export default EndValidityStep;
